console.log("--> animation.js");


var cemf =  cemf || {
  js: {}
};


cemf.js.Animation = function(params){
	
}


/*
   Objeto contendo todos os elementos que devem ser ajustados de acordo com o tamanho das telas

*/
cemf.js.Animation.prototype.paramsLayout = null;

/*
	Tamanho mínimo para restirar o Panel e Ajustar a tela de componentes
*/
cemf.js.Animation.prototype.maxWidth  = 480;

cemf.js.Animation.prototype.maxHeigth = 600;

cemf.js.Animation.prototype.isCelular = false;

cemf.js.Animation.prototype.pilhaToast = [];



cemf.js.Animation.prototype.screenSize = function(){
	console.log("--> screenSize()");

			var w = window,
		    d = document,
		    e = d.documentElement,
		    g = d.getElementsByTagName('body')[0],
		    x = w.innerWidth || e.clientWidth || g.clientWidth,
		    y = w.innerHeight|| e.clientHeight|| g.clientHeight;

		    var screen = {
		    				width:x,
		    				height:y
		    			};
		   	this.isCelular = (x <= this.maxWidth);
		 		   	 
			return screen;
}



/*
   Mensagems Informativa para Usuario
   Mensagems sequenciais são colocadas em Pilhas de execução.
*/
cemf.js.Animation.prototype.toast = function(msg){
	var toast = this;

		// var arr = [1, 2, 3, 4, 5, 6];
		// arr = arr.slice(0, 3);
		// console.log(arr);

		
   	  (toast.pilhaToast).push(msg);
   	  
	  if((toast.pilhaToast).length >= 1){
	  		Exibir();

	  		var interva_toast = setInterval(function(){

	      				 if((toast.pilhaToast).length > 0){
	      						Exibir();	      						
	      				}else{
	      					   
									clearInterval(interva_toast);
	      				}
	      	},3000);
	  }

	 function Exibir(){
	 							
					$("#snackbar")	
					 	.html(toast.pilhaToast[0])
					 	.fadeIn(100)
       					.addClass('show');
       				
       				

       			 setTimeout(
						function(){ 
								$("#snackbar")
								.fadeOut(500,function(){$("#snackbar").removeClass('show')});	   

								toast.pilhaToast = (toast.pilhaToast).slice(1,(toast.pilhaToast).length); 					
		   		}, 2500);

       			
	}

}




console.log("--> index.js");
'use strick';

var cemf =  cemf || {
  js: {}
};

cemf.js.TemplatePage = function(){}


cemf.js.TemplatePage.prototype.movimentoParaCima 		= false;
cemf.js.TemplatePage.prototype.ultimaPosicaoScroll 		= 0;
cemf.js.TemplatePage.prototype.toleranciaDesceMenu 		= 20;
cemf.js.TemplatePage.prototype.animation = null;
cemf.js.TemplatePage.prototype.connection = null;
cemf.js.TemplatePage.prototype.dados = null;


cemf.js.TemplatePage.prototype.listaDadosImageFullScreen = null;  // A lista de imagens para navegar pelo botão FullScreen Next e Prev
cemf.js.TemplatePage.prototype.idDadosFullScreen = null; // Id, posição na lista da imagem atual carregada


cemf.js.TemplatePage.prototype.exist = function(selector){
  return ($(selector).length > 0) ? true : false;
}

cemf.js.TemplatePage.prototype.capturaUrl = function(){

	var self = this;
	var url = window.location.href;
	var pos = url.search("#");
	console.log(pos);
	
	// caso não exista o # na url
	if(pos < 0){
		return false;
	}

	var section = url.substring(pos + 1);
	return section
	
}

cemf.js.TemplatePage.prototype.scrollEvent = function(){
	var self = this;


	var posicaoScroll = $(document).scrollTop();
		

	if( posicaoScroll  >= (self.ultimaPosicaoScroll + self.toleranciaDesceMenu)){
		self.movimentoParaCima = false;
		self.ultimaPosicaoScroll = posicaoScroll;
	
	}else if(posicaoScroll <= self.ultimaPosicaoScroll){
		self.movimentoParaCima = true;
		self.ultimaPosicaoScroll = posicaoScroll;	
	
	}

	 console.log(posicaoScroll);

	if(posicaoScroll < 37){
		$(".header-menu .container")
						.css({
								position:'relative',
								height:'86px',
								background:'transparent',
								// background:(self.animation.isCelular)?'transparent':'#920513',
							})
						.removeClass('shadow-top-z-3');
		if(self.animation.isCelular) $(".header-menu .container h1").css('left','138px');
		$("#logo-regui-2").css({width: '105px'});
	
		// $("logo-regui")
		// 				//.attr('src','img/logo_regui_brasil_2.png')
		// 				//.css('width','105px')
		// 				.fadeOut('fast',function(){
		// 					$("#logo-regui-2").fadeIn('fast');
		// 				});
		$(".header-menu .container h1").css("margin-top",'-24px');

	}else if( posicaoScroll > 37){
		var tamanho_layout = $('.boxed-layout').width();
		
		$(".header-menu .container")
						.css({
								position:'fixed',
								width:tamanho_layout,
								top:'0px',
								height:'68px',
								background:(self.animation.isCelular)?'#afa319':'transparent',
							})
						.addClass((self.animation.isCelular)?"shadow-top-z-3":"");
		if(self.animation.isCelular) $(".header-menu .container h1").css('left','3%');

		

		if($("#logo-regui-2").is(":visible")){
			console.log("Visible");

			$("#logo-regui-2").css({width: '90px'});

			// $("#logo-regui-2")
			// 				//.attr('src','img/logo_regui_brasil.png')
			// 				//.css('width','126px');
			// 				.fadeOut('fast',function(){
			// 					$("#logo-regui").slideDown('fast');
			// 				});
		}

		$(".header-menu .container h1").css("margin-top",'13px');
	}

 	

}
cemf.js.TemplatePage.prototype.transitionScroll = function(item){
			
			var self = this;
			var pos = 0;
			switch(item){
				case 'sobre': 		pos = 571; break;
				case 'social': 		pos = 2374; break;
				case 'contato': 	pos = 3601; break;
				case 'estrutura' :  pos = 3258; break;
			}

			if(self.exist( $(".bloco."+item) )){
				pos = $(".bloco."+item).offset().top - 50;	
				console.log($(".bloco."+item).offset());
			}else{
				console.log("Section " + item + " inexistente.");
				pos = -1;
			}
			
			if(pos > -1){
				var velocidade = 1000;

				if(velocidade < 200){
					velocidade = 200;
				}

				$('html, body').animate({
										scrollTop: pos
										}, velocidade, 'linear');
			}

			return pos;

}
cemf.js.TemplatePage.prototype.positionOffSet = function(item){

		var pos = 0;
		console.log(item);
			switch(item){
				case 'sobre': 		pos = 571; break;
				case 'social': 		pos = 2374; break;
				case 'contato': 	pos = 3601; break;
				case 'estrutura' :  pos = 2958; break;
			}
		return pos;
}

cemf.js.TemplatePage.prototype.scrollUp = function(){

		$('html, body').animate({
								scrollTop: 0
								}, ($('html').scrollTop() / 3), 'linear');

}

cemf.js.TemplatePage.prototype.openMenu = function(){

	   		if($(".mobile-menu-area nav").is(":visible")){
	   			$(".mobile-menu-area nav").fadeOut("slow");
	   			$(".mobile-menu-area figure").removeClass("rotateOpen");
	   			$("#open-menu img").attr('src',$("#_path").text()+"img/icons/system/ic_menu_white_24dp.png");
	   		}else{
	   			$(".mobile-menu-area nav").fadeIn("fast");
	   			$(".mobile-menu-area figure").addClass("rotateOpen");
	   			$("#open-menu img").attr('src',$("#_path").text()+"img/icons/system/ic_close_white_24dp.png");

	   		}

}


cemf.js.TemplatePage.prototype.animaQuemSomos = function(aux){
			var tamanho_layout = $('.boxed-layout').width();
	   		var distancia_layout = $('.boxed-layout').offset().left;
	   		

	   		//	console.log(distancia_layout);
	   		  // $('html, body').animate({
								// scrollTop: 0
								// }, 50, 'linear');

	   		if(aux){
		   		$(".header-title").css({
		   						position:'fixed',
		   						width:tamanho_layout,
		   						height:'200px',
		   						left:distancia_layout,
		   						'border-bottom-right-radius':'0px'
		   		}).removeClass('shadow-top-z-6');

		   		$(".header-container #logo-menu-bar").css({
		   					position:'fixed',
		   					left:distancia_layout + 8,
		   		});
		   		$(".header-content")
		   							.css({width:tamanho_layout})
		   							.removeClass('anima-out-header-content')
		   							.removeClass('none')
		   							.addClass('anima-in-header-content');
		   		$(".header-title .splash").fadeIn(1000);
		   		$(".header-title .icon-back").fadeIn(1000);
		   							


		   	}else{
		   	
		   		$(".header-title .splash").fadeOut(100);
		   		$(".header-title .icon-back").fadeOut(100);
		   		$(".header-title").css({
		   						position:'absolute',
		   						width:'135px',
		   						height:'150px',
		   						left:'0px',
		   						'border-bottom-right-radius':'125px'
		   		}).addClass('shadow-top-z-6');

		   		$(".header-container #logo-menu-bar").css({
		   					position:'absolute',
		   					left:'8px',
		   		});
				
			//	console.log(tamanho_layout);
				

				$(".header-content")
		   							.removeClass('anima-in-header-content')
		   							.addClass('anima-out-header-content');

		   	}

		   	return !aux;
}

cemf.js.TemplatePage.prototype.createActionMoveImage = function(dados){
	var self = this;

	
	var andar = dados.andar_click;
	var d_action = $("<div></div>");
		d_action.addClass('action-fotos');

	var d_prev = $("<div></div>");
		d_prev.addClass('icon-prev');

	var d_next = $("<div></div>");
		d_next.addClass('icon-next');
	var i_prev = $("<img></img>");
		i_prev.attr('src','img/icons/system/ic_play_circle_filled_white_white_48dp.png');
	var i_next = $("<img></img>");
		i_next.attr('src','img/icons/system/ic_play_circle_filled_white_white_48dp.png');

		// Procura UL a ser movimentada
		
		var template = (dados.template).find(".wrapper-carrousel")[0];

		$(template).animate({
									scrollLeft: andar
									}, 1500, 'linear');
		
		var action_prev = {
				click:function(){
					console.log("Prev...");
					// var template = $(this).parent().parent();
					// template = $(template).find(".wrapper-carrousel")[0];
					$(template).animate({
									scrollLeft: $(template).scrollLeft() - andar
									}, 500, 'linear');

				}
		};
		var action_next = {
				click:function(){
					console.log("Next...");
					// var template = $(this).parent().parent();
					// template = $(template).find(".wrapper-carrousel")[0];
					$(template).animate({
									scrollLeft: $(template).scrollLeft() + andar
									}, 500, 'linear');
				}
		};

	d_prev.on(action_prev);
	d_next.on(action_next);

	d_prev.append(i_prev);
	d_next.append(i_next);
	d_action.append(d_prev,d_next);

	$(dados.template).append(d_action);

	return d_action;

}

cemf.js.TemplatePage.prototype.criaListaCoquetel = function(dados){
	var self = this;
	var sizeLista = dados.length * 350;
	var ul = $("<ul></ul>");
	ul.css('width',sizeLista);

	dados.forEach(function(element,index){
		console.log(element);
		var li  = $("<li></li>");
		var d_card = $("<div></div>");
		d_card
				.addClass('card shadow-top-z-5 size-fotos coquetel');

		var d_wrapper = $("<div></div>");
		d_wrapper
				.addClass('wrapper-figure anima-figure-carrousel');

		var figure = $("<figure></figure>");
		figure.addClass('anima-figure-carrousel');

		var img = $("<img></img>");
		img
			.addClass('bounceIn animated')
			.attr('src',element.img);
		

		var footer = $("<footer></footer>");
		var h3 = $("<h3></h3>");
			h3
				.addClass('upper font-5')
				.text(element.titulo);

		var d_barra = $("<div></div>");
			d_barra.addClass('barra color-primary');

		var p1 = $("<p></p>");
			p1
				.addClass('font-3 color-text-3 sub-title no-bold no-ls')
				.text(element.desc);
		var p2 = $("<p></p>");
			p2
				.addClass('font-4 color-text-4 sub-title mt-5')
				.text(element.preco);
		var p3 = $("<p></p>");
			p3
				.addClass('font-1 color-text-1 no-ls sub-title')
				.text(element.obs);

		var action = {
				click:function(){
					console.log(element.img);
					console.log(element.titulo);
					var params = {
						'img': img.attr('src'),
						'titulo': element.titulo,
						'id_atual':index,
						'lista':dados,
					}
					self.fullScreenImage(params);
				}
		}

		d_wrapper.on(action);

		figure.append(img);
		d_wrapper.append(figure);
		footer.append(h3,d_barra,p1,p2,p3)
		d_card.append(d_wrapper,footer);
		li.append(d_card);
		ul.append(li);
	})

	return ul;
}

cemf.js.TemplatePage.prototype.alteraImagefullScreen = function(dados){
		var self = this;
		$('.fullScreen .content').css('background',dados.color || 'white');
		$('.fullScreen .foto img').attr('src',self.listaDadosImageFullScreen[self.idDadosFullScreen]['img']);
		$('.fullScreen .action p').html(self.listaDadosImageFullScreen[self.idDadosFullScreen]['titulo']);

}
cemf.js.TemplatePage.prototype.fullScreenImage = function(dados){
	var self = this;
	$('.fullScreen .foto img').attr('src',dados.img);
	$('.fullScreen .action p').html(dados.titulo);

	$('.fullScreen').fadeIn('fast',function(){
	
	});

	self.listaDadosImageFullScreen = dados.lista;
	self.idDadosFullScreen = dados.id_atual;

}

cemf.js.TemplatePage.prototype.atualizaInterface = function(){
	var self = this;

	$("#lista-coquetel").html(self.criaListaCoquetel(self.dados.get('coquetel')));
	self.createActionMoveImage({'template':$(".bloco.linha-coquetel"),'andar_click':500});

	$("#lista-coquetel-gourmet").html(self.criaListaCoquetel(self.dados.get('coquetel_gourmet')));
	self.createActionMoveImage({'template':$(".bloco.linha-coquetel-gourmet"),'andar_click':700});

	
	// $("#lista-panificacao").html(self.criaListaCoquetel(self.dados.get('panificacao')));
	// self.createActionMoveImage({'template':$(".bloco.linha-panificacao"),'andar_click':400});

		

}


cemf.js.TemplatePage.prototype.buscaDadosWeb = function(aux){
	console.log("Busca dados Web");

	var self = this;
	(self.connection)
				 				.execute((self.connection).server('dados'),{acao:'dados_web'},this)
						  		.done(function(data){
									//console.log('--> Done');
									if(data.hasOwnProperty('resposta')){
									 	var msg = data.resposta;
									    self.dados.replace(data.resposta);
									    self.atualizaInterface();
									}else{
										console.log(".reposta inexistente");
									}
								});

}

/*
	Recebe a instancia da comunicação
*/


cemf.js.TemplatePage.prototype.start = function(){
		console.log("--> start()");

	   var self = this;

		//self.connection = new cemf.js.Connection();
  		//self.dados = new cemf.js.Dados();	     		
  		self.animation = new cemf.js.Animation();
  		self.animation.screenSize();
  		var tentativa_click = 0;


  		// self.animation.toast("Ola Sou o Carlos");
  		//self.buscaDadosWeb();

  		

  		
  		window.setTimeout(function() {
		    
		    	var _offset = self.capturaUrl();
  				
  				// Movimentando o Cursor para o início da Pagina
				console.log(self.positionOffSet(_offset));

				if(_offset.length > 2){
			  	 $('html, body').animate({
										scrollTop: self.positionOffSet(_offset)
										}, 200, 'linear');
				}
		}, 2000);

     	
	
	   

	    // Capturando movimento do Scroll da tela
	   $(document).on('scroll',function(){
	   		self.scrollEvent();
	   })

	   // Botao enviar o formulario
	   $('#btn-contato-enviar').on("click",function(event) {
	 		
	 		if(tentativa_click > 0){
	 			console.log("Enviar pelo Whats");
	 			var text = $("#input_text").val();

	 			text = text.replace(/\s/g,"%20");
	 			window.location = "https://api.whatsapp.com/send?phone=5541999725055&text="+text;

	 		}else{
	 			console.log("Enviar por email");	
	 		}
	 		
	 		tentativa_click ++;
	 		$(".msg-error").html("Envio de e-mail ainda não autorizado, Clique novamente para enviar pelo WhatsApp");

		});

	   /*
	   		Evento para abrir a Parte de Quem somos.
	   */
	   
	  
	   
	   $("#open-menu").on("click",function(){
	   	 		//$(".mobile-menu-area nav").toggle();
	   		self.openMenu();
	   		
	   });

	   $("#scrollUp").on('click',function(e){
	   		e.preventDefault();
			self.scrollUp();
	   })

	   $(".header-menu ul li").on('click',function(){

			var id = $(this).attr('id');
			self.transitionScroll(id);
			self.openMenu();
		});

	    $(".header-menu ul li a").on('click',function(){

			var id = $(this).attr('id');
			self.transitionScroll(id);
			self.openMenu();
		});

		
	   // Caso o navegador não reconheça o comando .remove() ...  IE
		if (!('remove' in Element.prototype)) {
			  Element.prototype.remove = function() {
		        if (this.parentNode) {
		            this.parentNode.removeChild(this);
		        }
		    };
		}

		
		
}


$( document ).ready(function() {
	if($('.wrapper').length > 0){
			new cemf.js.TemplatePage().start();
	}

});

